export function Footer() {
  return (
    <footer className='footer'>
      <p className='footer__copyright'>&#169; Gym App</p>
    </footer>
  );
}
